/**
 * @license Copyright (c) 2023-2025, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */

import { isPluginOrGroupAvailable } from '../isPluginOrGroupAvailable/isPluginOrGroupAvailable';
import type { FeatureParsed, PluginParsed } from '../../components/PluginSelection/types';

export function isGroupSelected( group: Array<FeatureParsed | PluginParsed>, isGroupSingleChoice?: boolean ): boolean {
	const availableGroups = group.filter( isPluginOrGroupAvailable );

	if ( availableGroups.length === 0 ) {
		return false;
	}

	if ( isGroupSingleChoice ) {
		return availableGroups.some( item => item.isSelected );
	}

	return availableGroups.every( item => item.isSelected );
}
